import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { ReportGroup } from '../../../generated'

interface ReportSelectionSelectProps {
  value: string
  onChange: (value: string) => void
  groupId: string
  reportTemplates: (ReportGroup | null)[]
}

export const ReportSelectionSelect: React.FC<ReportSelectionSelectProps> = ({
  reportTemplates,
  value,
  onChange,
  groupId
}) => {
  const selectedGroup = reportTemplates?.find(group => group?.group === groupId)
  const selections = selectedGroup?.selections || []

  const selectedOption = selections.find(s => s.selection === value) || null

  return (
    <Autocomplete
      fullWidth
      disabled={!groupId}
      options={selections}
      getOptionLabel={option => option.label || ''}
      value={selectedOption}
      onChange={(_, newValue) => onChange(newValue?.selection || '')}
      renderInput={params => (
        <TextField
          {...params}
          label="Report Selection"
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#E0E0E0'
            }
          }}
        />
      )}
    />
  )
}
